/**
 * Checks if a given ISO datetime string is in the past (date-only).
 * @param {string} dateStr - An ISO 8601 datetime string.
 * @returns {boolean} - True if the date is before today, false otherwise.
 */
export function isPastDateNoTime(dateStr) {
  const inputDate = new Date(dateStr);
  const today = new Date();

  // Normalize both to midnight
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return inputDate < today;
}